import React from 'react';
import {
  InputLabel,
  MenuItem,
  Select,
  theme,
} from '@attain-sre/attain-design-system';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import * as Styled from './Tabs.styles';

export interface Tab {
  active?: boolean;
  activePath?: string;
  disabled?: boolean;
  element?: React.ReactNode;
  onClick?: (event?: any) => any;
  testID?: string;
  title?: string;
}

const Tab = ({
  active,
  activePath,
  disabled,
  element,
  onClick,
  testID,
  title,
}: Tab) => {
  const location = useLocation();
  const hasActivePath = activePath
    ? !!location.pathname.includes(activePath)
    : false;

  return (
    <Styled.Tab
      onClick={onClick}
      $disabled={disabled}
      className={active || hasActivePath ? 'active' : ''}
      {...(testID && { 'data-testid': testID })}
    >
      {element ? element : title}
    </Styled.Tab>
  );
};

interface TabsProps {
  tabs: Tab[];
  links?: boolean;
}

export const Tabs = ({ tabs }: TabsProps) => {
  const isDesktop = useMediaQuery({
    query: theme.mq.tabletPortraitUp,
  });

  // Store which tab is selected in mobile view
  const [selectedValue, setSelectedValue] = React.useState(
    tabs[0]?.title || ''
  );

  if (!isDesktop) {
    return (
      <Styled.Dropdown>
        <InputLabel data-testid="tabs-navigation-label">Navigation</InputLabel>

        <Select
          fullWidth
          value={selectedValue}
          variant="outlined"
          data-testid="tabs-mobile-select"
          onChange={(e) => {
            const newTitle = e.target.value as string;
            setSelectedValue(newTitle);

            // Invoke the onClick handler of the newly selected tab (if present)
            const selectedTab = tabs.find((tab) => tab.title === newTitle);
            if (selectedTab?.onClick) {
              selectedTab.onClick(e);
            }
          }}
        >
          {tabs
            .filter((tab) => !tab.disabled)
            .map((tab, i) => (
              <MenuItem
                key={i}
                value={tab.title}
                data-testid={`tabs-option-${tab.testID || i}`}
              >
                {tab.title}
              </MenuItem>
            ))}
        </Select>
      </Styled.Dropdown>
    );
  } else {
    return (
      <Styled.Wrapper>
        {tabs.map((tab, i) => (
          <Tab key={i} {...tab} />
        ))}
      </Styled.Wrapper>
    );
  }
};

export default Tabs;
